import { collection, QueryDocumentSnapshot } from "firebase/firestore";
import { db } from "~/integrations/firebase/firestore";
import {
  FirestoreWeeklySearchTermsDoc,
  FirestoreWeeklySearchTerm,
} from "reedy-data/models";

export type WeeklySearchTerms = FirestoreWeeklySearchTermsDoc;
export type SearchTerm = FirestoreWeeklySearchTerm;

const trendConverter = {
  toFirestore: (record: WeeklySearchTerms) => record,

  fromFirestore(
    snapshot: QueryDocumentSnapshot<FirestoreWeeklySearchTermsDoc>,
  ): WeeklySearchTerms {
    return snapshot.data();
  },
};

export const getSearchTermCollection = () =>
  collection(db, "searchTermsWeekly").withConverter(trendConverter);
